import classNames from "classnames";
import GameBoxWithTitle from "ui/atoms/GameBoxWithTitle";
import { PlaybackState } from "../types";
import VolumeSlider from "ui/atoms/VolumeSlider";
import useMeasure from "util/useMeasure";
import RainbowBackground from "../molecules/RainbowBackground/RainbowBackground";
import { GameQuestionFaderGrader } from "shared/games/types/GameQuestions";
import { refrenceTrackIds } from "../pages/referenceTrackConfig";

interface Props {
  volume: number;
  setVolume: (volume: number) => void;
  playbackState: PlaybackState | "failed";
  question: GameQuestionFaderGrader;
}

const maxVolume = 0;
export default function VolumeSelector(props: Props) {
  const { setVolume, volume, playbackState, question } = props;
  const [{ height, width }, ref] = useMeasure<HTMLDivElement>({
    key: "fader-grader",
  });
  const percentageOfVolumeComplete =
    (volume - question.minVolume) / (maxVolume - question.minVolume);

  return (
    <GameBoxWithTitle
      title={<GameTitle {...props} />}
      heightClassName="h-auto"
      className={"overflow-hidden"}
      ref={ref}
      titleBackgroundClassName="bg-black"
    >
      <RainbowBackground
        failed={playbackState === "failed"}
        height={height}
        width={width}
        percentComplete={percentageOfVolumeComplete}
      />

      <div
        id={refrenceTrackIds.fader}
        className={classNames("mx-auto max-w-[500px] px-2 pb-40 pt-20", {
          "pointer-events-none": playbackState === "failed",
        })}
      >
        <VolumeSlider
          onChange={setVolume}
          value={volume}
          theme="white"
          steps={question.steps}
          max={question.maxVolume}
          min={question.minVolume}
        />
      </div>
    </GameBoxWithTitle>
  );
}

function GameTitle({ playbackState }: Props) {
  if (playbackState === "failed") {
    return <span className={"text-red-500"}>Incorrect!</span>;
  }

  if (playbackState === "mix") {
    return (
      <span>
        Listening to <span className={"text-purple-400"}>Your Mix</span>
      </span>
    );
  }

  return (
    <span>
      Listening to the <span className={"text-purple-400"}>Reference</span>
    </span>
  );
}
